<template lang="pug">
.v-section-top-card.section-top-card(v-if="data" @mousemove="handleMouseMove" @mouseleave="handleMouseLeave")
	a.section-top-card__wrap-link(v-if="data.href" :href="data.href")

	template(v-if="data.type === 'video'")
		v-video.section-top-card__image(:type="data.type" :src="data.src" :controls="false" :muted="true" autoplay=true :loop="true" :playsinline="true")
	//template(v-else-if="data.type === 'youtube'" )
	//	v-video.section-top-card__image(:type="data.type" :src="data.src" :muted="true" autoplay=true :loop="true")
	template(v-else)
		img.section-top-card__image(
			v-if="data.src"
			ref="image"
			:src="data.src"
			:alt="data?.alt")


	a.section-top-card__link.btn.btn--lg.btn-gap(v-if="data.href && data.text" :href="data.href")
		.section-top-card__link-text {{ data.text }}
		.btn-arrow.btn__icon
			.btn-arrow__track
				.btn-arrow__track-item
					v-scope
						v-svg-icon.icon-arrow(icon="btn-arrow")
				.btn-arrow__track-item
					v-scope
						v-svg-icon.icon-arrow(icon="btn-arrow")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import gsap from 'gsap';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;


			// const cards = document.querySelectorAll('.section-top-card')
			// cards.forEach(card => card.addEventListener('mousemove', mouseMoveFunc));
			// function mouseMoveFunc(e) {
			// 	console.log(e.target)
			//
			//
			// 	const depth = 50;
			// 	const moveX = ((e.pageX)-(window.innerWidth/2))/depth;
			// 	const moveY = ((e.pageY)-(window.innerHeight/2))/depth;
			// 	gsap.to(".section-top-card__image", {
			// 		duration: 1,
			// 		x: moveX,
			// 		y: moveY,
			// 		ease: "slow",
			// 		stagger: 0.008,
			// 		overwrite: true
			// 	});
			// }
		},

		handleMouseMove(event) {
			if(this.$refs.image) {
				const el = this.$refs.image
				const r = el.getBoundingClientRect()



				el.style.setProperty('--x', event.clientX*2 - (r.left + Math.floor(r.width / 2)))
				el.style.setProperty('--y', event.clientY*2 - (r.top + Math.floor(r.height / 2)))
			}
		},

		handleMouseLeave(event) {
			if(this.$refs.image) {
				this.$refs.image.style.setProperty('--x', 0)
				this.$refs.image.style.setProperty('--y', 0)
			}
		}
	}
}

</script>